export default "__VITE_ASSET__Blx5xG0s__"